<template>
  <div>
    <div class="content">
      <div class="content-main" style="display: flex; align-items: flex-start; justify-content: space-between">
        <div>
          <div style="margin-bottom: 8px; display: flex; flex-direction: column">
            <el-space style="margin-bottom: 8px">
              <p><span style="font-weight: bold;">推荐功能的生效注册时间-安卓：</span><span v-if="!changDate">{{limitDate}}</span></p>
              <el-date-picker v-if="changDate" v-model="limitDate" type="date" placeholder="Pick a day" size="default" value-format="YYYY-MM-DD" style="width: 12em"/>
              <el-button size="default" v-if="!changDate" type="primary" @click="changDate = true">修改时间</el-button>
              <el-button size="default" v-if="changDate" type="primary" @click="submitDate('limitDate', limitDate)">确定</el-button>
              <el-button size="default" v-if="changDate" @click="canceDate">取消</el-button>
            </el-space>
            <el-space v-if="!isLinlu">
              <p><span style="font-weight: bold;">推荐功能的生效注册时间-IOS：</span><span v-if="!changIosDate">{{iosLimitDate}}</span></p>
              <el-date-picker v-if="changIosDate" v-model="iosLimitDate" type="date" placeholder="Pick a day" size="default" value-format="YYYY-MM-DD" style="width: 12em"/>
              <el-button size="default" v-if="!changIosDate" type="primary" @click="changIosDate = true">修改时间</el-button>
              <el-button size="default" v-if="changIosDate" type="primary" @click="submitDate('iosLimitDate', iosLimitDate)">确定</el-button>
              <el-button size="default" v-if="changIosDate" @click="canceIosDate">取消</el-button>
            </el-space>
          </div>
          <p style="color: #aaaaaa"><span style="color: red">* </span>小于配置时间的用户，无法使用推荐功能，只能使用筛选功能</p>
        </div>
        <div style="text-align: right">
          <div style="margin-bottom: 8px">
            <el-space>
              <p><span style="font-weight: bold;">密信功能的生效注册时间：</span><span v-if="!changSecretDate">{{secretLimitDate}}</span></p>
              <el-date-picker v-if="changSecretDate" v-model="secretLimitDate" type="date" placeholder="Pick a day" size="default" value-format="YYYY-MM-DD" style="width: 12em" />
              <el-button size="default" v-if="!changSecretDate" type="primary" @click="changSecretDate = true">修改时间</el-button>
              <el-button size="default" v-if="changSecretDate" type="primary" @click="submitDate('secretLimitDate', secretLimitDate)">确定</el-button>
              <el-button size="default" v-if="changSecretDate" @click="canceSecretDate">取消</el-button>
            </el-space>
          </div>
          <p style="color: #aaaaaa"><span style="color: red">* </span>小于配置时间的用户，无法使用密信功能，只能使用“聊一聊”功能</p>
        </div>
      </div>
      <div class="content-main">
        <p class="content-title" style="padding-bottom: 16px;" >被推荐用户参数条件</p>
        <div class="content-table" style="padding-bottom: 12px;">
          <el-table
              ref="multipleTableRef"
              :data="paramList[0]"
              style="width: 100%;"
              v-loading="loading"
              border
              :span-method="objectSpanMethodOne"
          >
            <el-table-column property="" label="参数类型" width="160">
              <template #default="scope">
                {{scope.row.type}}
              </template>
            </el-table-column>
            <el-table-column property="" label="发起人" width="120">
              <template #default="scope">
                {{scope.row.sex == 1?'男生':'女生'}}
              </template>
            </el-table-column>
            <el-table-column property="" label="年龄差距(<=)">
              <template #default="scope">
                <p v-if="!scope.row['show_' + scope.row.label + 'Diff' + (scope.row.sex == 1?'M':'F')]" @click="showEdit(scope.row, scope.row.label + 'Diff' + (scope.row.sex == 1?'M':'F'))">
                  {{scope.row[scope.row.label + 'Diff' + (scope.row.sex == 1?'M':'F')]}}
                </p>
                <el-input v-else type="text" v-model="scope.row[scope.row.label + 'Diff' + (scope.row.sex == 1?'M':'F')]"  @focusout="submit(scope.row, scope.row.label + 'Diff' + (scope.row.sex == 1?'M':'F') )" />
              </template>
            </el-table-column>
            <el-table-column property="" label="X天内未登录过">
              <template #default="scope">
                <p v-if="!scope.row['show_' + scope.row.label + 'LoginDay' + (scope.row.sex == 1?'M':'F')]" @click="showEdit(scope.row, scope.row.label + 'LoginDay' + (scope.row.sex == 1?'M':'F'))">
                  {{scope.row[scope.row.label + 'LoginDay' + (scope.row.sex == 1?'M':'F')]}}
                </p>
                <el-input v-else type="text" v-model="scope.row[scope.row.label + 'LoginDay' + (scope.row.sex == 1?'M':'F')]"  @focusout="submit(scope.row, scope.row.label + 'LoginDay' + (scope.row.sex == 1?'M':'F') )" />
              </template>
            </el-table-column>
            <el-table-column property="" label="X小时内登录过" >
              <template #default="scope">
                <p v-if="!scope.row['show_' + scope.row.label + 'LoginHour' + (scope.row.sex == 1?'M':'F')]" @click="showEdit(scope.row, scope.row.label + 'LoginHour' + (scope.row.sex == 1?'M':'F'))">
                  {{scope.row[scope.row.label + 'LoginHour' + (scope.row.sex == 1?'M':'F')]}}
                </p>
                <el-input v-else type="text" v-model="scope.row[scope.row.label + 'LoginHour' + (scope.row.sex == 1?'M':'F')]"  @focusout="submit(scope.row, scope.row.label + 'LoginHour' + (scope.row.sex == 1?'M':'F') )" />
              </template>
            </el-table-column>
            <el-table-column property="" label="被心动率低于X(%)" >
              <template #default="scope">
                <p v-if="!scope.row['show_' + scope.row.label + 'LoveRateMin' + (scope.row.sex == 1?'M':'F')]" @click="showEdit(scope.row, scope.row.label + 'LoveRateMin' + (scope.row.sex == 1?'M':'F'))">
                  {{scope.row[scope.row.label + 'LoveRateMin' + (scope.row.sex == 1?'M':'F')]}}
                </p>
                <el-input v-else type="text" v-model="scope.row[scope.row.label + 'LoveRateMin' + (scope.row.sex == 1?'M':'F')]"  @focusout="submit(scope.row, scope.row.label + 'LoveRateMin' + (scope.row.sex == 1?'M':'F') )" />
              </template>
            </el-table-column>
            <el-table-column property="" label="被心动率超过X(%)" >
              <template #default="scope">
                <p v-if="!scope.row['show_' + scope.row.label + 'LoveRateMax' + (scope.row.sex == 1?'M':'F')]" @click="showEdit(scope.row, scope.row.label + 'LoveRateMax' + (scope.row.sex == 1?'M':'F'))">
                  {{scope.row[scope.row.label + 'LoveRateMax' + (scope.row.sex == 1?'M':'F')]}}
                </p>
                <el-input v-else type="text" v-model="scope.row[scope.row.label + 'LoveRateMax' + (scope.row.sex == 1?'M':'F')]"  @focusout="submit(scope.row, scope.row.label + 'LoveRateMax' + (scope.row.sex == 1?'M':'F') )" />
              </template>
            </el-table-column>
            <el-table-column property="" label="X天内未被重复推荐" >
              <template #default="scope">
                <p v-if="!scope.row['show_' + scope.row.label + 'RepeatDay' + (scope.row.sex == 1?'M':'F')]" @click="showEdit(scope.row, scope.row.label + 'RepeatDay' + (scope.row.sex == 1?'M':'F'))">
                  {{scope.row[scope.row.label + 'RepeatDay' + (scope.row.sex == 1?'M':'F')]}}
                </p>
                <el-input v-else type="text" v-model="scope.row[scope.row.label + 'RepeatDay' + (scope.row.sex == 1?'M':'F')]"  @focusout="submit(scope.row, scope.row.label + 'RepeatDay' + (scope.row.sex == 1?'M':'F') )" />
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="content-main">
        <p class="content-title" style="padding-bottom: 16px;">推荐用户数量条件</p>
        <div class="content-table" style="padding-bottom: 12px;">
          <el-table
              ref="multipleTableRef"
              :data="paramList[1]"
              style="width: 100%;"
              v-loading="loading"
              border
              :span-method="objectSpanMethodTwo"
          >
            <el-table-column property="" label="参数类型" width="160">
              <template #default="scope">
                {{scope.row.type}}
              </template>
            </el-table-column>
            <el-table-column property="" label="发起人" width="120">
              <template #default="scope">
                {{scope.row.sex == 1?'男生':'女生'}}
              </template>
            </el-table-column>
            <el-table-column property="" label="发起人心动率>X (%)" >
              <template #default="scope">
                <p v-if="!scope.row['show_' + scope.row.label + 'RateMin' + (scope.row.sex == 1?'M':'F')]" @click="showEdit(scope.row, scope.row.label + 'RateMin' + (scope.row.sex == 1?'M':'F'))">
                  {{scope.row[scope.row.label + 'RateMin' + (scope.row.sex == 1?'M':'F')]}}
                </p>
                <el-input v-else type="text" v-model="scope.row[scope.row.label + 'RateMin' + (scope.row.sex == 1?'M':'F')]"  @focusout="submit(scope.row, scope.row.label + 'RateMin' + (scope.row.sex == 1?'M':'F') )" />
              </template>
            </el-table-column>
            <el-table-column property="" label="发起人心动率<Y(%)" >
              <template #default="scope">
                <p v-if="!scope.row['show_' + scope.row.label + 'RateMax' + (scope.row.sex == 1?'M':'F')]" @click="showEdit(scope.row, scope.row.label + 'RateMax' + (scope.row.sex == 1?'M':'F'))">
                  {{scope.row[scope.row.label + 'RateMax' + (scope.row.sex == 1?'M':'F')]}}
                </p>
                <el-input v-else type="text" v-model="scope.row[scope.row.label + 'RateMax' + (scope.row.sex == 1?'M':'F')]"  @focusout="submit(scope.row, scope.row.label + 'RateMax' + (scope.row.sex == 1?'M':'F') )" />
              </template>
            </el-table-column>
            <el-table-column property="" label="推荐异性批次<X" >
              <template #default="scope">
                <p v-if="!scope.row['show_' + scope.row.label + 'BatchMax' + (scope.row.sex == 1?'M':'F')]" @click="showEdit(scope.row, scope.row.label + 'BatchMax' + (scope.row.sex == 1?'M':'F'))">
                  {{scope.row[scope.row.label + 'BatchMax' + (scope.row.sex == 1?'M':'F')]}}
                </p>
                <el-input v-else type="text" v-model="scope.row[scope.row.label + 'BatchMax' + (scope.row.sex == 1?'M':'F')]"  @focusout="submit(scope.row, scope.row.label + 'BatchMax' + (scope.row.sex == 1?'M':'F') )" />
              </template>
            </el-table-column>
            <el-table-column property="" label="推荐异性批次>=Y" >
              <template #default="scope">
                <p v-if="!scope.row['show_' + scope.row.label + 'BatchMin' + (scope.row.sex == 1?'M':'F')]" @click="showEdit(scope.row, scope.row.label + 'BatchMin' + (scope.row.sex == 1?'M':'F'))">
                  {{scope.row[scope.row.label + 'BatchMin' + (scope.row.sex == 1?'M':'F')]}}
                </p>
                <el-input v-else type="text" v-model="scope.row[scope.row.label + 'BatchMin' + (scope.row.sex == 1?'M':'F')]"  @focusout="submit(scope.row, scope.row.label + 'BatchMin' + (scope.row.sex == 1?'M':'F') )" />
              </template>
            </el-table-column>
            <el-table-column property="" label="推荐数量最小值" >
              <template #default="scope">
                <p v-if="!scope.row['show_' + scope.row.label + 'NumMin' + (scope.row.sex == 1?'M':'F')]" @click="showEdit(scope.row, scope.row.label + 'NumMin' + (scope.row.sex == 1?'M':'F'))">
                  {{scope.row[scope.row.label + 'NumMin' + (scope.row.sex == 1?'M':'F')]}}
                </p>
                <el-input v-else type="text" v-model="scope.row[scope.row.label + 'NumMin' + (scope.row.sex == 1?'M':'F')]"  @focusout="submit(scope.row, scope.row.label + 'NumMin' + (scope.row.sex == 1?'M':'F') )" />
              </template>
            </el-table-column>
            <el-table-column property="" label="推荐数量最大值" >
              <template #default="scope">
                <p v-if="!scope.row['show_' + scope.row.label + 'Num' + (scope.row.sex == 1?'M':'F')]" @click="showEdit(scope.row, scope.row.label + 'Num' + (scope.row.sex == 1?'M':'F'))">
                  {{scope.row[scope.row.label + 'Num' + (scope.row.sex == 1?'M':'F')]}}
                </p>
                <el-input v-else type="text" v-model="scope.row[scope.row.label + 'Num' + (scope.row.sex == 1?'M':'F')]"  @focusout="submit(scope.row, scope.row.label + 'Num' + (scope.row.sex == 1?'M':'F') )" />
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="content-main">
        <p class="content-title" style="padding-bottom: 16px;">互动状态条件</p>
        <div class="content-table" style="padding-bottom: 12px;">
          <el-table
              ref="multipleTableRef"
              :data="paramList[2]"
              style="width: 100%;"
              v-loading="loading"
              border
              :span-method="objectSpanMethodOne"
          >
            <el-table-column property="" label="参数类型" width="160">
              <template #default="scope">
                {{scope.row.type}}
              </template>
            </el-table-column>
            <el-table-column property="" label="发起人" width="120">
              <template #default="scope">
                {{scope.row.sex == 1?'男生':'女生'}}
              </template>
            </el-table-column>
            <el-table-column property="" label="进入应用X天" >
              <template #default="scope">
                <p v-if="!scope.row['show_' + scope.row.label + 'EnterDay' + (scope.row.sex == 1?'M':'F')]" @click="showEdit(scope.row, scope.row.label + 'EnterDay' + (scope.row.sex == 1?'M':'F'))">
                  {{scope.row[scope.row.label + 'EnterDay' + (scope.row.sex == 1?'M':'F')]}}
                </p>
                <el-input v-else type="text" v-model="scope.row[scope.row.label + 'EnterDay' + (scope.row.sex == 1?'M':'F')]"  @focusout="submit(scope.row, scope.row.label + 'EnterDay' + (scope.row.sex == 1?'M':'F') )" />
              </template>
            </el-table-column>
            <el-table-column property="" label="进入应用X天内，最新互动时间大于Y小时" >
              <template #default="scope">
                <p v-if="!scope.row['show_' + scope.row.label + 'EnterDayBeforeHour' + (scope.row.sex == 1?'M':'F')]" @click="showEdit(scope.row, scope.row.label + 'EnterDayBeforeHour' + (scope.row.sex == 1?'M':'F'))">
                  {{scope.row[scope.row.label + 'EnterDayBeforeHour' + (scope.row.sex == 1?'M':'F')]}}
                </p>
                <el-input v-else type="text" v-model="scope.row[scope.row.label + 'EnterDayBeforeHour' + (scope.row.sex == 1?'M':'F')]"  @focusout="submit(scope.row, scope.row.label + 'EnterDayBeforeHour' + (scope.row.sex == 1?'M':'F') )" />
              </template>
            </el-table-column>
            <el-table-column property="" label="进入应用X天后，最新互动时间大于Y小时" >
              <template #default="scope">
                <p v-if="!scope.row['show_' + scope.row.label + 'EnterDayAfterHour' + (scope.row.sex == 1?'M':'F')]" @click="showEdit(scope.row, scope.row.label + 'EnterDayAfterHour' + (scope.row.sex == 1?'M':'F'))">
                  {{scope.row[scope.row.label + 'EnterDayAfterHour' + (scope.row.sex == 1?'M':'F')]}}
                </p>
                <el-input v-else type="text" v-model="scope.row[scope.row.label + 'EnterDayAfterHour' + (scope.row.sex == 1?'M':'F')]"  @focusout="submit(scope.row, scope.row.label + 'EnterDayAfterHour' + (scope.row.sex == 1?'M':'F') )" />
              </template>
            </el-table-column>
            <el-table-column property="" label="最新互动时间大于Y小时" >
              <template #default="scope">
                <p v-if="!scope.row['show_' + scope.row.label + 'Hour' + (scope.row.sex == 1?'M':'F')]" @click="showEdit(scope.row, scope.row.label + 'Hour' + (scope.row.sex == 1?'M':'F'))">
                  {{scope.row[scope.row.label + 'Hour' + (scope.row.sex == 1?'M':'F')]}}
                </p>
                <el-input v-else type="text" v-model="scope.row[scope.row.label + 'Hour' + (scope.row.sex == 1?'M':'F')]"  @focusout="submit(scope.row, scope.row.label + 'Hour' + (scope.row.sex == 1?'M':'F') )" />
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="content-main">
        <div style="padding-bottom: 16px;display: flex; align-items: center">
          <p class="content-title" >配置无需推荐全国用户的城市：</p>
          <div style="display: flex;">

            <Area v-if="showArea" title="" @areaChang='getArea($event)'/>
            <ElButtons icon="Plus" v-else :disabled="checkArea" @click="showArea = true">添加城市</ElButtons>
            <el-checkbox class="check" v-model="checkArea" @change="noArea()" style="margin-left: 12px;">不限城市</el-checkbox>
          </div>
        </div>
        <div class="content-table" style="padding-bottom: 12px;">
          <div style="display: flex; flex-wrap: wrap; align-items: center;">
            <el-tag v-for="(name, index) in selectCitys" size="large" :key="name" closable type="info" @close="delCity(index)" style="margin: 0 8px 8px 0">{{ name }}</el-tag>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getHomeRecommendCoeff, updateCoeffList } from '../../api/url'
import { postFormData, getFormData } from "@/api/api";
import {positiveIntReg} from "@/assets/shared/reg-constant";
import Area from '@/components/AreaSelect'

export default {
name: "RecommendParamHome",
  components: { Area },
  data() {
    return {
      isOnly: false,
      isLinlu: false,
      paramList: [
        [
          {type: '年龄合适', sex: 1, label:'age',     Diff:''},
          {type: '年龄合适', sex: 2, label:'age',     Diff:''},
          {type: '优质用户', sex: 1, label:'quality',             LoginDay: '',                                    LoveRate: '',    RepeatDay: ''  },
          {type: '优质用户', sex: 2, label:'quality',             LoginDay: '',                                    LoveRate: '',    RepeatDay: ''  },
          {type: '优先用户', sex: 1, label:'priority',                            LoginHour: '',                   LoveRate: '',    RepeatDay: ''  },
          {type: '优先用户', sex: 2, label:'priority',                            LoginHour: '',                   LoveRate: '',    RepeatDay: ''  },
          {type: '单向心动', sex: 1, label:'singleLove',                          LoginHour: '',                                    RepeatDay: ''  },
          {type: '单向心动', sex: 2, label:'singleLove',                          LoginHour: '',                                    RepeatDay: ''  },
          {type: '常规用户', sex: 1, label:'general',                                                               LoveRate: '',   RepeatDay: ''  },
          {type: '常规用户', sex: 2, label:'general',                                                               LoveRate: '',   RepeatDay: ''  },
          {type: '边缘用户', sex: 1, label:'margin',                              LoginHour: '',   LoveRate: '',                    RepeatDay: ''  },
          {type: '边缘用户', sex: 2, label:'margin',                              LoginHour: '',   LoveRate: '',                    RepeatDay: ''  },
          {type: '未认证用户', sex: 1, label:'notIdent',                                                                             RepeatDay: ''  },
          {type: '未认证用户', sex: 2, label:'notIdent',                                                                             RepeatDay: ''  },
        ],
        [
          {type: '优质用户', sex: 1, label:'qualityOne',                          BatchMax:'',                                           Num:'',   },
          {type: '优质用户', sex: 1, label:'qualityTwo',                          BatchMax:'',         BatchMin:'',                      Num:'',   },
          {type: '优质用户', sex: 1, label:'qualityThree',                                             BatchMin:'',                      Num:'',   },
          {type: '优质用户', sex: 2, label:'qualityOne',                          BatchMax:'',                                           Num:'',   },
          {type: '优质用户', sex: 2, label:'qualityTwo',                          BatchMax:'',         BatchMin:'',                      Num:'',   },
          {type: '优质用户', sex: 2, label:'qualityThree',                                             BatchMin:'',                      Num:'',   },

          {type: '优先用户', sex: 1, label:'priorityOne',                          BatchMax:'',                                           Num: '',  },
          {type: '优先用户', sex: 1, label:'priorityTwo',                          BatchMax:'',         BatchMin:'',                      Num: '',  },
          {type: '优先用户', sex: 1, label:'priorityThree',                                             BatchMin:'',                      Num: '',  },
          {type: '优先用户', sex: 2, label:'priorityOne',                          BatchMax:'',                                           Num: '',  },
          {type: '优先用户', sex: 2, label:'priorityTwo',                          BatchMax:'',         BatchMin:'',                      Num: '',  },
          {type: '优先用户', sex: 2, label:'priorityThree',                                             BatchMin:'',                      Num: '',  },

          {type: '单向心动', sex: 1, label:'singleLoveOne',    RateMin: '',                                                                       Num: '',               },
          {type: '单向心动', sex: 1, label:'singleLoveTwo',    RateMin: '',        RateMax: '',                                                   Num: '',               },
          {type: '单向心动', sex: 1, label:'singleLoveThree',                      RateMax: '',                                                   Num: '',               },
          {type: '单向心动', sex: 2, label:'singleLoveOne',    RateMin: '',                                                                       Num: '',               },
          {type: '单向心动', sex: 2, label:'singleLoveTwo',    RateMin: '',        RateMax: '',                                                   Num: '',               },
          {type: '单向心动', sex: 2, label:'singleLoveThree',  RateMin: '',        RateMax: '',                                                   Num: '',               },
          {type: '单向心动', sex: 2, label:'singleLoveFour',                       RateMax: '',                                                   Num: '',               },

          {type: '边缘用户', sex: 1, label:'marginOne',                               BatchMax:'',                           NumMin: '',              NumMax: '',                },
          {type: '边缘用户', sex: 1, label:'marginTwo',                               BatchMax:'',          BatchMin:'',     NumMin: '',              NumMax: '',                },
          {type: '边缘用户', sex: 1, label:'marginThree',                                                   BatchMin:'',     NumMin: '',              NumMax: '',                },
          {type: '边缘用户', sex: 2, label:'marginOne',                               BatchMax:'',                           NumMin: '',              NumMax: '',                },
          {type: '边缘用户', sex: 2, label:'marginTwo',                               BatchMax:'',          BatchMin:'',     NumMin: '',              NumMax: '',                },
          {type: '边缘用户', sex: 2, label:'marginThree',                                                   BatchMin:'',     NumMin: '',              NumMax: '',                },

          {type: '未认证用户', sex: 1, label:'notIdentOne',                         BatchMax:'',                              NumMin: '',              NumMax: '',               },
          {type: '未认证用户', sex: 1, label:'notIdentTwo',                         BatchMax:'',             BatchMin:'',     NumMin: '',              NumMax: '',               },
          {type: '未认证用户', sex: 1, label:'notIdentThree',                                                BatchMin:'',     NumMin: '',              NumMax: '',               },
          {type: '未认证用户', sex: 2, label:'notIdentOne',                         BatchMax:'',                              NumMin: '',              NumMax: '',               },
          {type: '未认证用户', sex: 2, label:'notIdentTwo',                         BatchMax:'',             BatchMin:'',     NumMin: '',              NumMax: '',               },
          {type: '未认证用户', sex: 2, label:'notIdentThree',                                                BatchMin:'',     NumMin: '',              NumMax: '',               },

          {type: '筛选推荐总数', sex: 1, label:'total',                                                                                             Num: '',               },
          {type: '筛选推荐总数', sex: 2, label:'total',                                                                                             Num: '',               },
        ],
        [
          {type: '普通', sex: 1, label:'interact',    EnterDay: '',     EnterDayBeforeHour: '',    EnterDayAfterHour:'',                      },
          {type: '普通', sex: 2, label:'interact',    EnterDay: '',     EnterDayBeforeHour: '',    EnterDayAfterHour:'',                      },

          {type: 'VIP', sex: 1, label:'interactVip',                                                                            Hour: '',      },
          {type: 'VIP', sex: 2, label:'interactVip',                                                                            Hour: '',      },
        ],
      ],
      loading: false,
      filterProAndCityList: [],

      limitDate: '',//注册时间
      limitDateOld: '',
      changDate: false,

      iosLimitDate: '',//ios注册时间
      iosLimitDateOld: '',
      changIosDate: false,


      secretLimitDate: '',//密信时间
      secretLimitDateOld: '',
      changSecretDate: false,

      // 城市
      checkArea: false,
      showArea: false,
      homeProvince: '',
      homeCity: '',
      selectCitys: [],
      selectProvinces: [],
      areaList: [],
    }
  },
  methods: {

    // 现居城市
    getArea(el) {
      // console.log(el)
      this.homeProvince = el.prov;
      this.homeCity = el.city;
      if(this.homeCity != '' && this.homeCity != null && this.homeCity != '不限'){
        let c = this.selectCitys.indexOf(this.homeCity);
        if(c == -1){
          this.selectCitys.push(this.homeCity)
          this.submitCity()
        }else{
          this.$message({
            message: '你已经添加了改城市',
            type: "error"
          });
        }
      }
    },


    delCity(index){
      this.selectCitys.splice(index,1);
      this.submitCity()
    },

    noArea(){
      this.selectCitys = [];
      this.citys = '全国'
      this.showArea = false
      this.resetArea = !this.resetArea;
      if(this.checkArea) {
        this.submitCity()
      }
    },

    objectSpanMethodOne({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        if (rowIndex % 2 === 0) {
          return {
            rowspan: 2,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },

    objectSpanMethodTwo({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        if (rowIndex == 0 || rowIndex == 6 || rowIndex == 19 || rowIndex == 25) {
          return {
            rowspan: 6,
            colspan: 1
          };
        }else if (rowIndex == 12) {
          return {
            rowspan: 7,
            colspan: 1
          };
        }else if (rowIndex == 31) {
          return {
            rowspan: 2,
            colspan: 1
          };
        }else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },

    getPage() {
      this.loading = true;
      getFormData(getHomeRecommendCoeff, {id: 3}).then((data)=>{
        let {code, msg} = data;
        if (code == 200) {
          let dataList = data.data
          let content = JSON.parse(dataList.content)
          this.selectCitys = content.filterProAndCityList
          this.limitDate = content.limitDate
          this.limitDateOld = content.limitDate
          this.secretLimitDate = content.secretLimitDate
          this.secretLimitDateOld = content.secretLimitDate
          this.iosLimitDate = content.iosLimitDate
          this.iosLimitDateOld = content.iosLimitDate
          if(this.selectCitys.length == 0) {
            this.checkArea = true
          }
          console.log(content)
          this.paramList.map(param => {
            for(let i=0; i < param.length; i++) {
              for(let j in param[i]) {
                let s = (param[i].sex == 1?'M':'F')
                if(dataList.content.indexOf(param[i].label + j + s) > -1) {
                  param[i]['key_' + param[i].label + j + s]= param[i].label + j + s
                  param[i][param[i].label + j + s] = content[param[i].label + j + s]
                }
              }
            }
          })
          this.paramList[0].map(item => {
            for(let k in item) {
              if(k == 'LoveRate') {
                let s = (item.sex == 1?'M':'F')
                if(item.label == 'margin') {
                  item[item.label + 'LoveRateMin' + s] = item[item.label + 'LoveRate' +s]
                  item['key_' + item.label + 'LoveRateMin' + s] = item['key_' + item.label + 'LoveRate' +s]
                }else {
                  item[item.label + 'LoveRateMax' + s] = item[item.label + 'LoveRate' +s]
                  item['key_' + item.label + 'LoveRateMax' + s] = item['key_' + item.label + 'LoveRate' +s]
                }
              }
            }
          })
          this.paramList[1].map(item => {
            for(let k in item) {
              if(k == 'NumMax') {
                let s = (item.sex == 1?'M':'F')
                item[item.label + 'Num' +s] = item[item.label + 'NumMax' +s]
                item['key_' + item.label + 'Num' +s] = item['key_' + item.label + 'NumMax' +s]
              }
            }
          })
          console.log(this.paramList)
        }else {
          this.$message({
            message: msg,
            type: 'warning',
            duration: 200
          })
        }
        this.loading = false
      }).catch(()=>{
        this.loading = false
      })
    },

    submit(row, value) {
      let role = /^\d+(\.\d{1,2})?$/
      if(!role.test(row[value])) {
        this.$message({
          message: '请输入正确的数值',
          type: 'warning',
          duration: 2000
        })
        row.value = 0
        return false
      }
      let param = {}
      param['id'] = 3;
      param['key'] = row['key_' + value]
      param['value'] = row[value]
      postFormData(updateCoeffList, param).then((data)=>{
        let {code, msg} = data;
        if (code == 200) {
          this.$message({
            message: msg,
            type: 'success',
            duration: 2000,
          })
          row['show_' + value] = false
          this.getPage()
        }else {
          this.$message({
            message: msg,
            type: 'warning',
            duration: 2000,
          })
        }
      })
    },

    submitCity() {
      let param = {}
      param['id'] = 3;
      param['key'] = 'filterProAndCityList'
      if(this.selectCitys.length > 0) {
        param['filterProAndCityList'] = this.selectCitys
      }else {
        param['filterProAndCityList'] = ''
      }
      postFormData(updateCoeffList, param).then((data)=>{
        let {code, msg} = data;
        if (code == 200) {
          this.$message({
            message: msg,
            type: 'success',
            duration: 2000,
          })
          this.getPage()
        }else {
          this.$message({
            message: msg,
            type: 'warning',
            duration: 2000,
          })
        }
      })
    },

    canceDate() {
      this.limitDate = this.limitDateOld
      this.changDate = false
    },

    canceIosDate() {
      this.iosLimitDate = this.iosLimitDateOld
      this.changIosDate = false
    },

    canceSecretDate() {
      this.secretLimitDate = this.secretLimitDateOld
      this.changSecretDate = false
    },

    submitDate(key, value) {
      if(!value) {
        this.$message({
          message: '时间不能为空',
          type: 'warning',
          duration: 2000
        })
        return false
      }
      let param = {}
      param['id'] = 3;
      param['key'] = key
      param['limitDate'] = value
      postFormData(updateCoeffList, param).then((data)=>{
        let {code, msg} = data;
        if (code == 200) {
          this.$message({
            message: msg,
            type: 'success',
            duration: 2000,
          })
          this.getPage()
          this.changDate = false
          this.changSecretDate = false
          this.changIosDate = false
        }else {
          this.$message({
            message: msg,
            type: 'warning',
            duration: 2000,
          })
        }
      })
    },

    showEdit(row, showLabel) {
      this.paramList.map(item => {
        item.map(p => {
          for(let s in p){
            // console.log(s)
            if(s.indexOf('show') > -1) {
              p[s] = false
            }
          }
        })
      })
      row['show_' + showLabel] = true
    },

  },
  mounted() {
    if(window.location.hostname == 'only.backstage.yiban1314.com') {
      this.isOnly = true
    }
    if(window.location.hostname == 'backstage.youban1314.cn' || window.location.port == '20030' ) {
      this.isLinlu = true
    }
    this.getPage()
  }
}
</script>

<style scoped>
.item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 32px;
}
.edit-btn {
  width: 32px;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #ffffff;
  border: none;
  border-radius: 50%;
  cursor: pointer;
}
.edit-btn:hover {
  background-color: #6fb6ff;
  color: #ffffff;
}
p {
  cursor: pointer;
}

.content-title {
  cursor: text;
}
</style>
